import React, { useEffect, useState } from 'react';

function Contact({ setEmail, setFirstName, setLastName, setPhone, translations }) {
  const setValue = (e, updateFunction) => {
    const stringvalue = e.target.value?.trim();
    if (stringvalue) {
      updateFunction(stringvalue);
    } else {
      e.target.value = '';
    }
  };

  return (
    <div className="sfpr__contact col-12">
      <span className="heading6">{translations.Contact}</span>
      <div>
        <div className="sfpr__inputField col-12">
          <label htmlFor="email">{translations.Email} *</label>
          <input required onChange={(e) => setEmail(e.target.value)} type="email" id="email" />
        </div>
        <div className="sfpr__inputField col-12">
          <label htmlFor="firstname">{translations.FirstName} *</label>
          <input required maxLength="40" onChange={(e) => setValue(e, setFirstName)} type="text" id="firstname" />
        </div>
        <div className="sfpr__inputField col-12">
          <label htmlFor="lastname">{translations.LastName} *</label>
          <input required maxLength="40" onChange={(e) => setValue(e, setLastName)} type="text" id="lastname" />
        </div>
        <div className="sfpr__inputField col-12">
          <label htmlFor="phone">{translations.PhoneNumber}</label>
          <input onChange={(e) => setPhone(e.target.value)} type="tel" id="phone" />
        </div>
      </div>
    </div>
  );
}
export default Contact;
